import { noActive } from './no-active';
export const filterButton = (buttonMap, view) => {
    Object.values(buttonMap)
        .filter((item) => item.enable(view))
        .forEach((item) => {
        var _a;
        const disable = (_a = item.disable) === null || _a === void 0 ? void 0 : _a.call(item, view);
        if (disable) {
            item.$.classList.add('hide');
            return;
        }
        item.$.classList.remove('hide');
        const active = item.active(view);
        if (active) {
            item.$.classList.add('active');
            return;
        }
        item.$.classList.remove('active');
    });
    return noActive(buttonMap, view);
};
//# sourceMappingURL=filter-button.js.map